/*
 * ⚠️  WARNING: BRIDGE LOGIC - DO NOT MODIFY WITHOUT #team-frontend-tech APPROVAL ⚠️
 *
 * This file contains critical bridge logic that enables communication between the
 * Ember app (apps/embercom) and React app (apps/teammate-app). Any modifications
 * to this file can break the integration between the two applications.
 *
 * Before making any changes to this file, please reach out to #team-frontend-tech
 * for review and approval.
 */

import { dispatchBridgeEvent, type RouteChangeEventPayload } from '@/utils/bridge';

type RouteChangedArgs = RouteChangeEventPayload;

/**
 * Notifies the host app that the React route has changed.
 */
export function routeChanged(args: RouteChangedArgs) {
  dispatchBridgeEvent('route:change', args);
}

/**
 * Notifies the host app that the React app has booted.
 */
export function routeBooted() {
  dispatchBridgeEvent('route:boot');
}

export const isRenderedAsIsland = () => Boolean(window.ReactTeammateApp);
